<template>
  <div>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="documentsLists"
      :server-items-length="meta.total"
      :footer-props="footerProps"
      :options="options"
      :page="page"
      :items-per-page="itemsPerPage"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :multi-sort="multiSort"
      v-on="listeners"
    >
      <template v-slot:item.action="{ item }">
        <action-slot-component
          :item="item"
          route-name="documents-lists.show"
          :route-params="{ id: item.id }"
          @show="$emit('show', item)"
        />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { isEqual } from 'lodash';
import { dateFormat } from '@/modules/_global/filters';
import ActionSlotComponent from '@/modules/_global/_components/ActionSlotComponent.vue';

export default {
  name: 'DocumentsListsList',
  components: { ActionSlotComponent },

  filters: {
    dateFormat
  },

  props: {
    documentsLists: {
      type: Array,
      required: true
    },
    meta: {
      type: Object,
      default: () => ({
        total: -1
      })
    },
    options: {
      type: Object,
      default: () => {}
    },
    page: {
      type: Number,
      default: 1
    },
    itemsPerPage: {
      type: Number,
      default: 10
    },
    sortBy: {
      type: [String, Array],
      default: 'id'
    },
    sortDesc: {
      type: [Boolean, Array],
      default: false
    },
    multiSort: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    footerProps: {
      showFirstLastPage: true,
      itemsPerPageOptions: [10, 50, 100]
    }
  }),

  computed: {
    listeners: function() {
      return Object.assign({}, this.$listeners, {
        'update:options': this.updateOptions
      });
    },

    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          align: 'left',
          sortable: true,
          value: 'id',
          width: '70px'
        },
        {
          text: this.$t('ITEM.TITLE'),
          value: 'name'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          width: 40,
          align: 'center',
          sortable: false
        }
      ];
    }
  },

  methods: {
    updateOptions(options) {
      if (isEqual(options, this.options)) {
        return;
      }

      this.$emit('update:options', options);
    },
    show(item) {
      this.$emit('show', item);
    }
  }
};
</script>
